'use client'

import styles from './Stepper.module.scss'
import styled from 'styled-components'

import React, { Fragment } from 'react'

import Meter from 'Atoms/Meter'
import Svg from 'Atoms/Svg'
import Typography from 'Atoms/Typography'

const Stepper = ({ activeStepWrapper, steps, size, intent, brand, tone, stepperDataTestId, onStepClick }) => {
  if (!steps) return false
  if (steps.length === 1) return false

  let { activeStep, activeStepIntent, activeStepBrand, activeStepTone } = activeStepWrapper

  activeStep = Number(activeStep)
  activeStepIntent = activeStepIntent ?? intent
  activeStepBrand = activeStepBrand ?? brand
  activeStepTone = activeStepTone ?? tone

  const snapFlex = (index) => (index === 0 ? 'flex-start' : index === steps.length - 1 ? 'flex-end' : 'center')

  return (
    <StyledStepperGrid stepCount={steps.length} size={size}>
      {steps.map(({ svg, subtitle, title, dataTestId }, i) => (
        <Fragment key={i}>
          <StyledStepContainer
            align={snapFlex(i)}
            data-testid={`stepper_${stepperDataTestId}_${dataTestId}`}
            onClick={(_) => (i <= activeStep && !!onStepClick ? onStepClick(i) : null)}
            clickableSteps={!!onStepClick && i <= activeStep}
          >
            <Svg
              icon={svg}
              size={size}
              brand={i <= activeStep ? activeStepBrand : null}
              intent={i <= activeStep ? activeStepIntent : null}
              tone={i <= activeStep ? activeStepTone : 'superfluous'}
            />
            <StyledDetailContainer align={snapFlex(i)}>
              <Typography font="bold" size={0.875} dataTesting={`stepper_${stepperDataTestId}_${dataTestId}_title`}>
                {title}
              </Typography>
              <Typography size={0.875} dataTesting={`stepper_${stepperDataTestId}_${dataTestId}_subtitle`}>
                {subtitle}
              </Typography>
            </StyledDetailContainer>
          </StyledStepContainer>
          {i < steps.length - 1 ? (
            <StyledMeter meterCount={steps.length - 1} size={size}>
              <Meter
                className={styles.meter}
                brand={i <= activeStep ? activeStepBrand : null}
                intent={i <= activeStep ? activeStepIntent : null}
                tone={i <= activeStep ? activeStepTone : 'superfluous'}
                max={1}
                value={i < activeStep ? 1 : 0}
                height={size / 2}
              />
            </StyledMeter>
          ) : (
            false
          )}
        </Fragment>
      ))}
    </StyledStepperGrid>
  )
}

const StyledMeter = styled.div`
  display: flex;
  flex-grow: 1;
  margin: ${(props) => props.size * 4}px 0 0 0;
`

const StyledStepperGrid = styled.div`
  display: grid;
  grid-template-columns:
    repeat(${(props) => props.stepCount - 1}, ${(props) => props.size * 16}px 1fr)
    ${(props) => props.size * 16}px;
  gap: 0.5rem;
`

const StyledDetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${(props) => props.align};

    @media (max-width: 1023px) {
        display: none;
    }
}
`

// Forbidden CSS below: text content will extend beyond the grid column. Use nowrap to prevent wrapping to fit
// in column.
const StyledStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: flex-start;
  white-space: nowrap;
  align-items: ${(props) => props.align};
  &:hover {
    cursor: ${(props) => (props.clickableSteps ? 'pointer' : 'auto')};
  }
`

export default Stepper
